import HeroCard from './HeroCard'
export default HeroCard
